import type { SellerAccountBlockReasonDto } from './api/sellers.api';

export const SELLER_ACCOUNT_BLOCK_REASON_LABELS: Record<SellerAccountBlockReasonDto, string> = {
  RUDE_CUSTOMER_CONTACT: 'Некорректное общение с пользователем',
  FAKE_ORDERS: 'Фиктивные заказы',
  SYSTEMATIC_RULE_VIOLATION: 'Систематическое нарушение правил',
  REPEATED_INACTION_ORDER_AUTO_CANCEL:
    'Повторные отмены заказов (автоотмена за бездействие или отмена продавцом)',
  REPEATED_LOW_RATING_ORDERS: 'Три заказа подряд с рейтингом ниже 3 звёзд',
};

/** Причины, которые админ выбирает вручную (авто-причины ставит только система). */
export const SELLER_ACCOUNT_BLOCK_SELECT_OPTIONS: {
  value: SellerAccountBlockReasonDto;
  label: string;
}[] = (
  ['RUDE_CUSTOMER_CONTACT', 'FAKE_ORDERS', 'SYSTEMATIC_RULE_VIOLATION'] as const
).map((value) => ({
  value,
  label: SELLER_ACCOUNT_BLOCK_REASON_LABELS[value],
}));
